// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2717":"css/admin-app.6653","9337":"css/app.6653"}[chunkId] + ".css";
};